import { addHours, format } from 'date-fns'
import FileDownload from 'js-file-download'
import Moment from 'moment'
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useState, useCallback } from 'react'
import DatePicker from 'react-datepicker'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  Button,
  Dropdown,
  // Segment,
  // List,
  // Image,
  Icon,
  Input,
  Message,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from 'semantic-ui-react'
import api from '../../services/api'
import 'react-datepicker/dist/react-datepicker.css'
import { FaEnvelope, FaEnvelopeOpenText } from 'react-icons/fa'
import { FaFileCircleExclamation, FaRegTrashCan } from 'react-icons/fa6'

import { getAllTabulationsRequest } from '~/store/modules/tabulacoes/actions'
import {
  changeTicketsTypeRequest,
  changeTicketsUserRequest,
  showTicketsRequest,
} from '~/store/modules/tickets/actions'
import { listUsersRequest } from '~/store/modules/usuarios/actions'

import { toast } from 'react-toastify'
import { useGlobalContext } from '../../contexts/GlobalContext'
import {
  Container,
  ContainerButtonsMenu,
  ContainerMenuHorizontal,
  ListSemantic,
  Menu,
  MenuSuperiror,
} from './styles'
// import api from '../../services/api'

// const statusOptions = [
//   { key: 'todos', text: 'Todos', value: 'todos' },
//   { key: 'abertos', text: 'Abertos', value: 'abertos' },
//   { key: 'fechados', text: 'Fechados', value: 'fechados' },
//   { key: 'pendentes', text: 'Pendentes', value: 'pendentes' },
//   { key: 'meus_tickets', text: 'Meus Tickets', value: 'meus_tickets' },
// ]

const statusString = ['', 'aberto', 'fechado', 'pendente']
// const statusSemantic = ['', 'green', 'black', 'yellow']

function getTabulationName(tabulacoes, id) {
  // eslint-disable-next-line no-unused-vars
  for (const tabulacao of tabulacoes) {
    if (tabulacao.id === id) {
      return tabulacao.nome
    }

    if (tabulacao.tabulations.length > 0) {
      const tabulationName = getTabulationName(tabulacao.tabulations, id)
      if (tabulationName) {
        return tabulationName
      }
    }
  }
  return null
}

const qtdSelectOptions = [
  { key: '20', value: '20', text: '20' },
  { key: '50', value: '50', text: '50' },
  { key: '100', value: '100', text: '100' },
]

export default function Tickets() {
  const { globalState, globalDispatch } = useGlobalContext()
  const {
    visualizacao,
    visualizacaoUser,
    selectqtdContatos,
    currentPage,
    totalCount,
    totalPages,
    proto,
    de,
    para,
    cpf,
    startDate,
    endDate,
  } = globalState.tickets_filters

  // const [selectqtdContatos, setSelectqtdContatos] = useState('20')
  // const [currentPage, setCurrentPage] = useState(1)
  // const [totalCount, setTotalCount] = useState(100)
  // const [totalPages, setTotalPages] = useState(2)

  const [loading, setLoading] = useState(false)
  const [tickets, setTickets] = useState([])
  const [ticketStatusList, setTicketStatusList] = useState([])
  // const [visualizacao, setVisualizacao] = useState('todos')
  // const [visualizacaoUser, setVisualizacaoUser] = useState('todos')

  const [listStatus, setListStatus] = useState([])
  const dispatch = useDispatch()
  const [showSearch, setShowSearch] = useState(false)
  // const [proto, setProto] = useState('')
  // const [de, setDe] = useState('')
  // const [cpf, setCpf] = useState('')
  // const [para, setPara] = useState('')

  // let start = new Moment(new Date())
  // start.subtract(30, 'days')
  // start = new Moment(start.format('YYYY-MM-DD')).toDate()
  // const [startDate, setStartDate] = useState(null)
  // let final = new Moment(new Date())
  // final = final.add(30, 'days')
  // const [endDate, setEndDate] = useState(null)
  const [downloadLoading, setDownloadLoading] = useState(false)

  const { usuarios } = useSelector((state) => state.usuarios)
  const tabulacoes = useSelector((state) => state.tabulacoes)
  const profile = useSelector((state) => state.user.profile)

  const handleExportFilter = useCallback(() => {
    setDownloadLoading(true)

    api
      .get('/export/tickets/filter', {
        params: {
          inicio: startDate
            ? format(addHours(startDate, 3), 'yyyy-MM-dd HH:mm:ss')
            : undefined,
          termino: endDate
            ? format(addHours(endDate, 3), 'yyyy-MM-dd HH:mm:ss')
            : undefined,
          visualizacao: visualizacao ? visualizacao : 'todos',
          visualizacaoUser,
          de,
          para,
          proto,
          parametro: cpf,
        },
        responseType: 'blob',
        timeout: 360000, // 6 minutos
      })
      .then((response) => {
        setDownloadLoading(false)
        FileDownload(response.data, 'chamados.xlsx')
      })
      .catch((error) => {
        toast.error('Erro ao exportar os chamados')
        setDownloadLoading(false)
      })
  }, [startDate, endDate, visualizacao, visualizacaoUser, de, para, proto, cpf])

  const handleExport = useCallback(() => {
    setDownloadLoading(true)

    api
      .get('/export/tickets', {
        params: {
          fk_id_dominio: profile.id_dominio,
        },
        responseType: 'blob',
        timeout: 360000, // 6 minutos
      })
      .then((response) => {
        setDownloadLoading(false)
        FileDownload(response.data, 'chamados.xlsx')
      })
      .catch((error) => {
        toast.error('Erro ao exportar os chamados')
        setDownloadLoading(false)
      })
  }, [profile.id_dominio])

  const fetchTicketStatus = useCallback(async () => {
    try {
      const { data } = await api.get(
        `/domains/${profile.id_dominio}/ticketstatus`,
      )
      setTicketStatusList([
        { key: 'todos', text: 'Todos', value: 'todos' },
        ...data.map((status) => {
          return { key: status.id, text: status.nome, value: status.id }
        }),
      ])
    } catch (error) {
      console.error('Error fetching ticket status:', error)
      toast.error('Erro ao buscar status dos tickets')
    }
  }, [profile.id_dominio])

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const getTickets = useCallback(async () => {
    setLoading(true)
    const { data } = await api.get('/tickets', {
      params: {
        inicio: startDate
          ? format(addHours(startDate, 3), 'yyyy-MM-dd HH:mm:ss')
          : undefined,
        termino: endDate
          ? format(addHours(endDate, 3), 'yyyy-MM-dd HH:mm:ss')
          : undefined,
        visualizacao: visualizacao === '' ? 'todos' : visualizacao,
        visualizacaoUser: visualizacaoUser === '' ? 'todos' : visualizacaoUser,
        de,
        para,
        proto,
        parametro: cpf,
        page: currentPage - 1,
        limit: selectqtdContatos,
      },
    })

    const localTotalPages = Math.ceil(data.count / selectqtdContatos)
    if (localTotalPages < currentPage && currentPage !== 1) {
      // setCurrentPage(1)

      globalDispatch({
        type: 'SET_DATA',
        payload: {
          tickets_filters: {
            ...globalState.tickets_filters,
            currentPage: 1,
          },
        },
      })
    }

    // setTotalCount(data.count)

    // globalDispatch({
    //   type: 'SET_DATA',
    //   payload: {
    //     tickets_filters: {
    //       ...globalState.tickets_filters,
    //       totalCount: data.count,
    //     },
    //   },
    // })

    console.log('data.count', data.count)
    console.log(data.rows)
    setTickets(data.rows)
    setLoading(false)
    // setTotalPages(Math.ceil(data.count / selectqtdContatos))

    globalDispatch({
      type: 'SET_DATA',
      payload: {
        tickets_filters: {
          ...globalState.tickets_filters,
          totalPages: Math.ceil(data.count / selectqtdContatos),
          totalCount: data.count,
        },
      },
    })
  }, [
    visualizacao,
    visualizacaoUser,
    startDate,
    endDate,
    de,
    para,
    proto,
    cpf,
    currentPage,
    selectqtdContatos,
    // globalDispatch,
    // globalState,
  ])

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    getTickets()
  }, [])

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    getTickets()
  }, [currentPage, selectqtdContatos])

  useEffect(() => {
    fetchTicketStatus()
  }, [fetchTicketStatus])

  useEffect(() => {
    dispatch(getAllTabulationsRequest({ domainId: profile.id_dominio }))
    dispatch(listUsersRequest(profile))
  }, [dispatch, profile])

  const getStatusList = useCallback(async () => {
    const { data } = await api.get(
      `/domains/${profile.id_dominio}/ticketstatus`,
    )
    setListStatus(data)
  }, [profile])

  useEffect(() => {
    getStatusList()
  }, [getStatusList])

  return (
    <Container>
      {/* {!showSearch && (
        <Message>
          <Button
            type="button"
            color="blue"
            onClick={() => {
              setShowSearch(true)
            }}
          >
            Pesquisa
          </Button>
        </Message>
      )} */}
      {showSearch && (
        <Message>
          <MenuSuperiror isVisible={showSearch}>
            <ContainerMenuHorizontal>
              <Menu>
                <p>Status</p>

                <Dropdown
                  placeholder="Selecione um status"
                  fluid
                  selection
                  options={ticketStatusList}
                  value={visualizacao}
                  onChange={(e, { value }) => {
                    // dispatch(changeTicketsTypeRequest(value))
                    // setVisualizacao(value)
                    globalDispatch({
                      type: 'SET_DATA',
                      payload: {
                        tickets_filters: {
                          ...globalState.tickets_filters,
                          visualizacao: value,
                          currentPage: 1,
                        },
                      },
                    })
                  }}
                />

                {/* <li className={visualizacao === 'todos' ? 'ativo' : ''}>
                  <button
                    type="button"
                    onClick={() => dispatch(changeTicketsTypeRequest('todos'))}
                  >
                    Todos
                  </button>
                </li>
                <li className={visualizacao === 'abertos' ? 'ativo' : ''}>
                  <button
                    type="button"
                    onClick={() =>
                      dispatch(changeTicketsTypeRequest('abertos'))
                    }
                  >
                    Abertos
                  </button>
                </li>
                <li className={visualizacao === 'fechados' ? 'ativo' : ''}>
                  <button
                    type="button"
                    onClick={() =>
                      dispatch(changeTicketsTypeRequest('fechados'))
                    }
                  >
                    Fechados
                  </button>
                </li>
                <li className={visualizacao === 'pendentes' ? 'ativo' : ''}>
                  <button
                    type="button"
                    onClick={() =>
                      dispatch(changeTicketsTypeRequest('pendentes'))
                    }
                  >
                    Pendentes
                  </button>
                </li>
                <li className={visualizacao === 'meus_tickets' ? 'ativo' : ''}>
                  <button
                    type="button"
                    onClick={() =>
                      dispatch(changeTicketsTypeRequest('meus_tickets'))
                    }
                  >
                    Meus Tickets
                  </button>
                </li> */}
                {/* <li className={visualizacao === 'deletados' ? 'ativo' : ''}>
                  <button
                    type="button"
                    onClick={() =>
                      dispatch(changeTicketsTypeRequest('deletados'))
                    }
                  >
                    Deletados
                  </button>
                </li> */}
              </Menu>

              <Menu>
                <p>Usuários</p>

                <Dropdown
                  placeholder="Select Friend"
                  fluid
                  selection
                  options={[
                    { key: 'todos', text: 'Todos', value: 'todos' },
                    ...usuarios.map((item) => ({
                      key: item.id,
                      text: item.nome,
                      value: item.id,
                    })),
                  ]}
                  value={visualizacaoUser}
                  onChange={(e, { value }) => {
                    // dispatch(changeTicketsUserRequest(value))
                    // setVisualizacaoUser(value)
                    globalDispatch({
                      type: 'SET_DATA',
                      payload: {
                        tickets_filters: {
                          ...globalState.tickets_filters,
                          visualizacaoUser: value,
                          currentPage: 1,
                        },
                      },
                    })
                  }}
                />

                {/* <li className={visualizacaoUser === 'todos' ? 'ativo' : ''}>
                  <button
                    type="button"
                    onClick={() => dispatch(changeTicketsUserRequest('todos'))}
                  >
                    Todos
                  </button>
                </li>
                {usuarios.map((item) => {
                  return (
                    <li
                      key={item.id}
                      className={visualizacaoUser === item.id ? 'ativo' : ''}
                    >
                      <button
                        type="button"
                        onClick={() =>
                          dispatch(changeTicketsUserRequest(item.id))
                        }
                      >
                        {item.nome}
                      </button>
                    </li>
                  )
                })} */}
              </Menu>
              <Menu>
                <div className="Search_Control">
                  <label htmlFor="protocolo">Protocolo</label>
                  <Input
                    id="protocolo"
                    type="text"
                    value={proto}
                    onChange={(e) => {
                      // setProto(e.target.value)

                      globalDispatch({
                        type: 'SET_DATA',
                        payload: {
                          tickets_filters: {
                            ...globalState.tickets_filters,
                            proto: e.target.value,
                            currentPage: 1,
                          },
                        },
                      })
                    }}
                  />
                </div>
              </Menu>
              <ContainerMenuHorizontal>
                {profile.dominio !== 'rodobank.cloudcom.com.br' && (
                  <div className="Search_Control">
                    <label htmlFor="originador">Originador</label>
                    <Input
                      id="originador"
                      type="text"
                      value={de}
                      onChange={(e) => {
                        // setDe(e.target.value)

                        globalDispatch({
                          type: 'SET_DATA',
                          payload: {
                            tickets_filters: {
                              ...globalState.tickets_filters,
                              de: e.target.value,
                              currentPage: 1,
                            },
                          },
                        })
                      }}
                    />
                  </div>
                )}

                <div className="Search_Control">
                  <label htmlFor="de">Cpf/Cnpj</label>
                  <Input
                    id="de"
                    type="text"
                    value={cpf}
                    onChange={(e) => {
                      // setCpf(e.target.value)

                      globalDispatch({
                        type: 'SET_DATA',
                        payload: {
                          tickets_filters: {
                            ...globalState.tickets_filters,
                            cpf: e.target.value,
                            currentPage: 1,
                          },
                        },
                      })
                    }}
                  />
                </div>

                {profile.dominio !== 'rodobank.cloudcom.com.br' && (
                  <div className="Search_Control">
                    <label htmlFor="destino">Destino</label>
                    <Input
                      id="destino"
                      type="text"
                      value={para}
                      onChange={(e) => {
                        // setPara(e.target.value)

                        globalDispatch({
                          type: 'SET_DATA',
                          payload: {
                            tickets_filters: {
                              ...globalState.tickets_filters,
                              para: e.target.value,
                              currentPage: 1,
                            },
                          },
                        })
                      }}
                    />
                  </div>
                )}
              </ContainerMenuHorizontal>
              <ContainerMenuHorizontal>
                <div className="Search_Control">
                  <label htmlFor="start">Inicio</label>
                  <div className="ui input">
                    <DatePicker
                      id="start"
                      showPopperArrow={false}
                      selected={startDate}
                      onChange={(date) => {
                        // setStartDate(date)

                        globalDispatch({
                          type: 'SET_DATA',
                          payload: {
                            tickets_filters: {
                              ...globalState.tickets_filters,
                              startDate: date,
                              currentPage: 1,
                            },
                          },
                        })
                      }}
                      showTimeSelect
                      timeFormat="HH:mm:ss"
                      timeIntervals={15}
                      timeCaption="time"
                      dateFormat="dd-MM-yyyy HH:mm:ss"
                      className="input_date"
                      withPortal
                    />
                  </div>
                </div>
                <div className="Search_Control">
                  <label htmlFor="end">Termino</label>
                  <div className="ui input">
                    <DatePicker
                      id="end"
                      showPopperArrow={false}
                      selected={endDate}
                      onChange={(date) => {
                        // setEndDate(date)

                        globalDispatch({
                          type: 'SET_DATA',
                          payload: {
                            tickets_filters: {
                              ...globalState.tickets_filters,
                              endDate: date,
                              currentPage: 1,
                            },
                          },
                        })
                      }}
                      showTimeSelect
                      timeFormat="HH:mm:ss"
                      timeIntervals={15}
                      timeCaption="time"
                      dateFormat="dd-MM-yyyy HH:mm:ss"
                      className="input_date"
                      withPortal
                    />
                  </div>
                </div>
              </ContainerMenuHorizontal>
            </ContainerMenuHorizontal>
            <ContainerButtonsMenu>
              <div>
                <Button
                  type="button"
                  color="red"
                  onClick={() => {
                    setShowSearch(false)
                  }}
                >
                  <Icon name="close" />
                  Fechar
                </Button>
              </div>

              <div>
                <Button
                  loading={downloadLoading}
                  disabled={downloadLoading}
                  type="button"
                  // fluid
                  color="green"
                  onClick={handleExportFilter}
                >
                  <Icon name="download" />
                  Exportar Busca
                </Button>
              </div>
              <div>
                <Button
                  loading={downloadLoading}
                  disabled={downloadLoading}
                  type="button"
                  // fluid
                  color="blue"
                  onClick={handleExport}
                >
                  <Icon name="download" />
                  Exportar Tudo
                </Button>
              </div>

              <div>
                <Button
                  type="button"
                  onClick={() => {
                    getTickets()
                  }}
                >
                  <Icon name="search" />
                  Pesquisar
                </Button>
              </div>

              <div>
                <Button
                  color="teal"
                  type="button"
                  onClick={() => {
                    // Reset all filters
                    globalDispatch({
                      type: 'SET_DATA',
                      payload: {
                        tickets_filters: {
                          visualizacao: 'todos',
                          visualizacaoUser: 'todos',
                          selectqtdContatos: '20',
                          proto: '',
                          de: '',
                          para: '',
                          cpf: '',
                          startDate: null,
                          endDate: null,
                          currentPage: 1,
                        },
                      },
                    })
                  }}
                  style={{ display: 'flex', gap: '4px' }}
                >
                  <FaRegTrashCan />
                  Limpar pesquisa
                </Button>
              </div>
            </ContainerButtonsMenu>
          </MenuSuperiror>
        </Message>
      )}

      <ListSemantic>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flex: 1,
            marginTop: '5px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {!showSearch && (
              <Button color="blue" icon onClick={() => setShowSearch(true)}>
                <Icon name="filter" />
              </Button>
            )}
            <Pagination
              size="mini"
              boundaryRange={0}
              defaultActivePage={1}
              ellipsisItem={null}
              firstItem={'<<'}
              lastItem={'>>'}
              siblingRange={1}
              totalPages={totalPages}
              onPageChange={(e, { activePage }) => {
                // setCurrentPage(activePage)

                // console.log({
                //   activePage,
                // })

                globalDispatch({
                  type: 'SET_DATA',
                  payload: {
                    tickets_filters: {
                      ...globalState.tickets_filters,
                      currentPage: activePage,
                    },
                  },
                })
              }}
              activePage={currentPage}
              prevItem={'<'}
              nextItem={'>'}
              disabled={loading}
            />
            <div>
              <strong> Total: </strong>
              <span style={{ fontWeight: 'bold' }}>{totalCount}</span>
              <span> Chamados</span>
            </div>
          </div>

          <Select
            placeholder="Quantidade de itens"
            options={qtdSelectOptions}
            // defaultValue="20"
            onChange={(e, { value }) => {
              // setCurrentPage(1) // Reset to first page when changing items per page
              // setSelectqtdContatos(value)

              globalDispatch({
                type: 'SET_DATA',
                payload: {
                  tickets_filters: {
                    ...globalState.tickets_filters,
                    currentPage: 1,
                    selectqtdContatos: value,
                  },
                },
              })
            }}
            value={selectqtdContatos}
          />
        </div>
      </ListSemantic>

      <ListSemantic>
        <Table celled>
          <TableHeader>
            <TableRow>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                #
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Data
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Status
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Fechado Primeiro Contato
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Tabulação
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Cpf/Cnpj
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Originador
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Contato
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                DID
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                BU
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Agente
              </TableHeaderCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {tickets.map((ticket) => {
              return (
                <TableRow key={ticket.id}>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    <Link to={`chamado/${ticket.id}`}>{ticket.id}</Link>
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {Moment(ticket.inicio).format('DD-MM-YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      display: 'flex',
                      gap: '20px',
                      justifyContent: 'start',
                      alignItems: 'center',
                    }}
                    warning={!['red', 'green'].includes(ticket.status_color)}
                    negative={ticket.status_color === 'red'}
                    positive={ticket.status_color === 'green'}
                  >
                    {ticket.status_color === 'red' && (
                      <FaEnvelopeOpenText color={ticket.status_color} />
                    )}
                    {ticket.status_color !== 'red' && (
                      <FaEnvelope color={ticket.status_color} />
                    )}
                    {ticket.status}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.fechado_primeiro_contato === 1 ? 'Sim' : 'Não'}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.tabulacao}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.campos_agenda_origem?.find(
                      (item) => item.nome_campo === 'cpf/cnpj',
                    )
                      ? ticket.campos_agenda_origem?.find(
                          (item) => item.nome_campo === 'cpf/cnpj',
                        ).conteudo
                      : ''}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.de.did ? ticket.de.did : ticket.de}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.descricao_origem}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.para.did ? ticket.para.did : ticket.para}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.descricao_destino}
                  </TableCell>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {ticket.usuario}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </ListSemantic>
    </Container>
  )
}
